<template>
	<div style="overflow-y: scroll;height: 570px;">
		<div class="spinner-wrapper" v-if="loader">
			<div class="spinner-grow text-success " role="status">
				<span class="sr-only"></span>
			</div>
			<div class="spinner-grow text-danger" role="status">
				<span class="sr-only"></span>
			</div>

		</div>
	<div class="table mt-1  col-12"
		 v-for="(value, name,index) in this.viewforModalItems">
		<div style="text-align: center">

			<span style="font-weight: bold">{{name}}</span>
		</div>
		<table class="table b-table table-striped" fixed size="xs">
			<thead>
			<tr>

				<th style="width: 5%;text-align: center">№</th>
				<th class="alignedRight"
					style="width: 18%">
					{{$t('reference.name')}}
				</th>
				<th class="alignedRight"
					style="width: 6%">
					{{$t('goods.artikul')}}
				</th>

				<th style="width: 10%" class="alignedCenter">{{$t('goods.barcode')}}</th>
				<th style="width: 10%" class="alignedCenter">{{$t('goods.color')}}</th>
				<th style="width: 6%" class="alignedCenter">{{$t('goods.brand')}}</th>
				<th class="textAlignCenter" style="width: 4%">{{$t('sale.kol-vo')}}</th>
				<!--<th class="alignedRight" style="width: 12%">Кол-во Транзакции</th>-->
				<!--<th class="textAlignCenter" style="width: 8%">{{ $t('prices.item.sum') }}</th>-->
				<!--<th class="textAlignCenter" style="width: 13%">{{-->
					<!--$t('prices.item.lastPriceWholesale') }}-->
				<!--</th>-->
				<!--<th class="textAlignCenter" style="width: 10%">{{ $t('prices.item.sum-new') }}-->
				<!--</th>-->


			</tr>
			</thead>
			<tbody>
			<tr v-for="(item, index) in value" :key="item.itemId">
				<td style="text-align: center">{{index+1}}</td>


				<td>{{item.name}}
				<td>{{item.artikul}}
				</td>

				<!--<td>{{value[value.length-1].maxValue}}</td>-->
				<td>{{item.barcode}}</td>
				<td>{{item.colorName}}</td>
				<td>{{item.brandName}}</td>
				<td style="text-align: center">{{item.balance}}</td>

				<!--<td style="text-align: center">{{item.incomeUzs| currency({-->
					<!--symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',-->
					<!--thousandsSeparator: ' '-->
					<!--})}}-->
				<!--</td>-->
				<!--<td style="text-align: center">{{item.priceWholesale| currency({-->
					<!--symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',-->
					<!--thousandsSeparator: ' '-->
					<!--})}}-->
				<!--</td>-->
				<!--<td style="text-align: center">{{item.priceUzs| currency({-->
					<!--symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',-->
					<!--thousandsSeparator: ' '-->
					<!--})}}-->
				<!--</td>-->


			</tr>
			<tr v-if="value.items">
				<td v-if="value.items.length==0" colspan="11"><h4 style="text-align: center">Пока
					нет
					доступных данных</h4>
				</td>
			</tr>
			</tbody>

		</table>
		<!--<div class="row" style="display: flex;justify-content:space-between">-->
			<!--<div class="col-4">-->
				<!--<nav>-->
					<!--&lt;!&ndash;<b-pagination size="sm" :total-rows="value.total" :per-page="search.limit"&ndash;&gt;-->
								  <!--&lt;!&ndash;:value="currentPageMethod(value.depId)"&ndash;&gt;-->
								  <!--&lt;!&ndash;:prev-text="$t('pagination.prev')"&ndash;&gt;-->
								  <!--&lt;!&ndash;:next-text="$t('pagination.next')"&ndash;&gt;-->
								  <!--&lt;!&ndash;@input="paginateByDep($event, value.depId)"&ndash;&gt;-->
								  <!--&lt;!&ndash;hide-goto-end-buttons/>&ndash;&gt;-->
				<!--</nav>-->
			<!--</div>-->
			<!--&lt;!&ndash;<div class="col-2">&ndash;&gt;-->

				<!--&lt;!&ndash;<b-button style="float: right;" variant="success" size="sm"&ndash;&gt;-->
						  <!--&lt;!&ndash;@click="openZayavka(value)">Создать заявку&ndash;&gt;-->
				<!--&lt;!&ndash;</b-button>&ndash;&gt;-->
			<!--&lt;!&ndash;</div>&ndash;&gt;-->
		<!--</div>-->
	</div>
	</div>
</template>

<script>

	import {mapState} from "vuex";

	export default {
        name: "ViewRequest",
		data(){
			return {
				loader:false,
			}
		},
		methods:{

		},
		computed:{
			...mapState('warehouse', [
				'viewforModalItems'
			]),
		},
		created(){
			this.loader = true;
			if (this.viewforModalItems) {
				setTimeout(()=>{
					this.loader = false;
				},5)
			}
		}
    }
</script>

<style scoped>
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
